import { createReducer } from 'AppSrc/core/reducers/create-reducer';
import {
  FETCH_DISPLAY_OPTIONS_REQUEST,
  FETCH_DISPLAY_OPTIONS_SUCCESS,
  FETCH_DISPLAY_OPTIONS_ERROR,
  CLEAR_DISPLAY_OPTIONS_FOR_FIELD_ID,
} from 'AppSrc/core/components/forms/form-base-components/redux/display-options/actions-display-options';




const displayOptionsDefaultState = {
  displayOptionsDataById: {},
};


const fetchDisplayOptionsRequest = (state, action) => ({
  ...state,
  displayOptionsDataById: {
    ...state.displayOptionsDataById,
    [action.payload.fieldId]: {
      ...state.displayOptionsDataById[action.payload.fieldId],
      fetching: true,
      hasFetched: false,
      displayList: state.displayOptionsDataById[action.payload.fieldId] ? state.displayOptionsDataById[action.payload.fieldId].displayList : [],
      displayOptions: state.displayOptionsDataById[action.payload.fieldId] ? state.displayOptionsDataById[action.payload.fieldId].displayOptions : [],
    },
  },
});

const fetchDisplayOptionsSuccess = (state, action) => ({
  ...state,
  displayOptionsDataById: {
    ...state.displayOptionsDataById,
    [action.payload.fieldId]: {
      ...state.displayOptionsDataById[action.payload.fieldId],
      fetching: false,
      hasFetched: true,
      displayList: action.payload.displayList ? action.payload.displayList : state.displayOptionsDataById[action.payload.fieldId].displayList,
      displayOptions: action.payload.displayOptions ? action.payload.displayOptions : state.displayOptionsDataById[action.payload.fieldId].displayOptions,
    },
  },
});

const fetchDisplayOptionsError = (state, action) => ({
  ...state,
  displayOptionsDataById: {
    ...state.displayOptionsDataById,
    [action.payload.fieldId]: {
      ...state.displayOptionsDataById[action.payload.fieldId],
      fetching: false,
      hasFetched: true,
    },
  },
});

const clearDisplayOptionsForFieldId = (state, action) => ({
  ...state,
  displayOptionsDataById: {
    ...state.displayOptionsDataById,
    [action.payload.fieldId]: {
      ...state.displayOptionsDataById[action.payload.fieldId],
      displayList: [],
      displayOptions: [],
    },
  },
});


const actionHandlers = {
  [FETCH_DISPLAY_OPTIONS_REQUEST]: fetchDisplayOptionsRequest,
  [FETCH_DISPLAY_OPTIONS_SUCCESS]: fetchDisplayOptionsSuccess,
  [FETCH_DISPLAY_OPTIONS_ERROR]: fetchDisplayOptionsError,
  [CLEAR_DISPLAY_OPTIONS_FOR_FIELD_ID]: clearDisplayOptionsForFieldId,
};

const displayOptionsReducer = createReducer(displayOptionsDefaultState, actionHandlers);


export {
  displayOptionsDefaultState,
  displayOptionsReducer,
};
